import React, { useMemo } from 'react';
import { Card, Empty } from 'antd';
import { Column } from '@ant-design/charts';
import './styles.css';
import { chartDateFormatter, generateConfig } from '../../helpers';
import { StatisticsPeriod } from '../../types';

interface BarChartProps {
  title: string;
  data?: any[];
  xField: string;
  yField: string;
  xTitle: string;
  yTitle: string;
  period: StatisticsPeriod;
}

const BarChart: React.FC<BarChartProps> = ({
  title,
  data,
  xField,
  yField,
  xTitle,
  yTitle,
  period,
}) => {
  const formatter = useMemo(() => chartDateFormatter(period), [period]);
  const chartConfig = useMemo(
    () => generateConfig(data, xField, yField, xTitle, yTitle, formatter),
    [data, xField, yField, xTitle, yTitle, formatter]
  );

  return (
    <Card className={'ant-card--chart'} title={title}>
      {data && <Column {...chartConfig} />}
      {!data && <Empty />}
    </Card>
  );
};

export default BarChart;
